$(".nav-link.dropdown_click").click(function (event) {
  event.preventDefault();
  var menuItem = $(this).closest(".menu-item");
  var subMenu = menuItem.find(".sub-menu.collapse");
  subMenu.toggleClass("show");
  menuItem.toggleClass("active");
});

/*============== FAQ SETUP SCRIPT :ST ====================  */
document.addEventListener("DOMContentLoaded", function () {
  const questionHeaders = document.querySelectorAll(
    ".faq-page-question-header"
  );

  questionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const parent = header.parentElement;
      const isActive = parent.classList.contains("active");

      // Collapse all items
      document.querySelectorAll(".faq-page-question").forEach((item) => {
        item.classList.remove("active");
      });

      // Expand clicked item if it was not active
      if (!isActive) {
        parent.classList.add("active");
      }
    });
  });

  if (
    window.location.href ===
    "https://donpablocoffee.com/products/don-pablo-colombian-decaf-coffee"
  ) {
    const optionDivs = document.querySelectorAll('[id^="option"]');

    optionDivs?.forEach((optionDiv) => {
      const firstRadio = optionDiv.querySelector('input[type="radio"]');

      if (firstRadio) {
        firstRadio.checked = true;
        firstRadio.dispatchEvent(new Event("change"));
      }
    });
  }
});

/*============== FAQ SETUP SCRIPT :ND ====================  */

/*============== VARIANT SUBMIT GUARD :ST ====================*/
(function () {
  var form = document.getElementById("AddToCartForm");
  if (!form) return;

  // product JSON is stored HTML-escaped on the form element by Liquid
  var rawJson = form.getAttribute("data-product-json");
  if (!rawJson) return;

  var product;
  try {
    product = JSON.parse(rawJson);
  } catch (e) {
    console.warn("[variant-guard] Could not parse product JSON", e);
    return;
  }

  form.addEventListener("submit", function () {
    // Collect the value of every checked radio, in group order
    var selectedOptions = [];
    var groups = form.querySelectorAll(".radio-btn-group");
    for (var g = 0; g < groups.length; g++) {
      var checked = groups[g].querySelector("input[type='radio']:checked");
      if (checked) selectedOptions.push(checked.value);
    }

    if (!selectedOptions.length) return;

    // Find the variant whose options match the selection exactly
    var variants = product.variants || [];
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      var match = true;
      for (var o = 0; o < selectedOptions.length; o++) {
        if (variant["option" + (o + 1)] !== selectedOptions[o]) {
          match = false;
          break;
        }
      }
      if (match) {
        var sel = document.getElementById("productSelect");
        if (sel && String(sel.value) !== String(variant.id)) {
          console.info(
            "[variant-guard] Correcting productSelect from",
            sel.value,
            "→",
            variant.id,
            "(" + variant.title + ")"
          );
          sel.value = String(variant.id);
        }
        break;
      }
    }
  });
})();
/*============== VARIANT SUBMIT GUARD :ND ==================== */
